import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { addData, deleteData, loadData, updateData } from "../../../../config/data";
import axios from "axios";
import EmptyAsset from "../emptyAsset";
import Swal from "sweetalert2";
import Lang from "../../../../config/lang";
import { useProfileTab } from "../../ProfileTabContext";

const SkillsForm = ({ setIsFading, updatePercentage, profileCompletion }) => {
    const { lang, name } = useSelector((state) => state.globalReducer);
    const { currentTabIndex, setCurrentTabIndex } = useProfileTab();
    const [isEdit, setIsEdit] = useState(false);
    const [skills, setSkills] = useState([]);
    const [localskills, setLocalSkills] = useState([]);
    const applicantID = localStorage?.getItem("applicantID");
    const userToken = localStorage?.getItem('authToken') || '';
    const [isEmpty, setisEmpty] = useState(true)
    const [isLoading, setisLoading] = useState('');


    const loadSkillsData = async () => {
        loadData({
            url: "ApplicantSkillList",
            params: [{ title: "filter", value: `applicant:${applicantID}` }],
            userToken,
        }).then((res) => {
            if (res?.data) {
                const resData = res.data;
                setSkills(res.data);
                if (resData) {
                    setisEmpty((resData).length < 1)
                }
            }
        });
    };

    useEffect(() => {
        loadSkillsData();
    }, []);

    const handleChange = (index, field, value) => {
        const updatedSkills = [...localskills];
        updatedSkills[index][field] = value;
        setLocalSkills(updatedSkills);
    };

    const handleAdd = () => {
        setLocalSkills([
            ...localskills,
            {
                skillListID: null,
                applicantID: applicantID,
                skillName: "",
                skillStatus: '',
                notes: ""
            }
        ]);
    };

    const saveSkill = async (skill) => {
        try {
            if (skill.skillListID) {
                await updateData({
                    url: "ApplicantSkillList",
                    userToken,
                    reqBody: {
                        skillListID: skill.skillListID,
                        applicantID: applicantID,
                        skillName: skill.skillName,
                        skillStatus: skill.skillStatus,
                        notes: "",
                    },
                });
            } else {
                await addData({
                    url: "ApplicantSkillList",
                    userToken,
                    reqBody: {
                        applicantID: applicantID,
                        skillName: skill.skillName,
                        skillStatus: skill.skillStatus || '',
                        notes: "",
                    },
                });
            }
        } catch (error) {
            console.error("Failed to save skill:", error);
        }
    };

    // Handle save all skills
    const handleSave = async () => {
        setisLoading(true);
        for (let skill of localskills) {
            await saveSkill(skill);
        }
        loadSkillsData();
        setisLoading(false);
    };

    const handleDelete = async (skill) => {
        try {
            if (skill.skillListID) {
                await deleteData({ url: "ApplicantSkillList", id: skill.skillListID, userToken });
            }
            setSkills(skills.filter(a => a.skillListID !== skill.skillListID));
        } catch (error) {
            console.error("Failed to delete skill:", error);
        }
    };
    const handleLocalDelete = async (index) => {
        try {
            setLocalSkills(localskills.filter((_, i) => i !== index));
        } catch (error) {
            console.error("Failed to delete skill:", error);
        }
    };

    const isFormReady = () => {
        const hasEmptyId = localskills.some(item => !item.skillName || !item.skillStatus);
        return !hasEmptyId;
    }

    const SkillTag = ({ index, item }) => {
        return (
            <div key={item?.skillListID} className="flex flex-row items-center gap-1 w-fit p-[13px] mr-3 mb-3" style={{
                borderColor: 'rgb(0 0 0 / 10%)',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: 10
            }}>
                <div className="mr-3.5">
                    <p className="text-gray-800 font-medium font-[12px]">{item.skillName}</p>
                    <p className="font-[10px]">{Lang(lang, `${item.skillStatus}`.toLocaleLowerCase())}</p>
                </div>

                <div className={(item.skillStatus === 'Advanced' ? 'bg-[#B9F8CF] text-[#016630]' : item.skillStatus === 'Intermediate' ? 'bg-[#FFD6A7] text-[#9F2D00]' : 'bg-[#BEDBFF] text-[#193CB8]') + " flex flex-row items-center rounded-lg px-3 py-2 text-sm w-fit h-fit"}>
                    <p className="font-[14px] mr-2 font-medium">{Lang(lang, `${item.skillStatus}`.toLocaleLowerCase())}</p>
                    {isEdit && <a href="" onClick={(e) => {
                        e.preventDefault()
                        handleDelete(item)
                    }}><img src={"/asset/icon/close.svg"} className="h-3 w-3 mb-1" /></a>}

                </div>
            </div>
        );
    }

    const showError = (error) => {
        Swal.fire({
            title: 'Error!',
            text: error || 'ERROR!',
            icon: 'error',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };


    return (
        <div>

            <div className="mt-4 bg-white p-6 rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.05)]" style={{ minHeight: window.innerHeight - 300 }}>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-blue-700 font-medium md:text-[20px] text-[17px] flex items-center space-x-2 cursor-pointer">
                        <img src={"/asset/icon/skills_blue.svg"} className="w-[16px] mr-1" />
                        <span>{Lang(lang, 'skills_tech')}</span>
                    </h2>
                    {!isEdit && (
                        <button
                            onClick={() => setIsEdit(true)}
                            className="flex border border-gray-300 rounded-full px-5 py-2 text-sm text-white bg-red-500 hover:bg-red-600"
                        >
                            <img src={"/asset/icon/edit.svg"} className="w-[16px] mr-1" />
                            Edit
                        </button>
                    )}
                </div>


                {skills.length === 0 && localskills.length === 0 ?
                    <div className="w-full">
                        <EmptyAsset title={Lang(lang, 'no_skill')} desc={Lang(lang, 'no_skill_desc')} />
                        {isEdit && <button
                            type="button"
                            onClick={handleAdd}
                            className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
                        >
                            + {Lang(lang, 'add_skills')}
                        </button>}
                        <div className="flex justify-end w-full mt-3">
                            <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'skillIsRequired')}</p></div>
                    </div>
                    :
                    <div>
                        {(skills.filter(obj => obj?.skillStatus === 'Advanced') || []).length !== 0 &&
                            <div>
                                <h1 className="text-gray-700 font-medium mb-3 text-black items-center flex flex-row">
                                    {Lang(lang, 'advance')} <div className="mx-2 h-2 w-2 rounded-full bg-[#00C950]" /> <p className="text-[12px] font-normal">({(skills.filter(obj => obj?.skillStatus === 'Advanced') || []).length})</p>
                                </h1>
                                <div className="flex flex-row flex-wrap">
                                    {skills.filter(obj => obj?.skillStatus === 'Advanced')?.map((skill, index) => (<SkillTag index={index} item={skill} />))}
                                </div>
                                <div>
                                </div>

                            </div>}
                        {(skills.filter(obj => obj?.skillStatus === 'Intermediate') || []).length !== 0 && <div>
                            <div className="bg-[#48494B] h-[0.5px] mt-3 mb-5 w-full" />
                            <h1 className="text-gray-700 font-medium mb-3 text-black items-center flex flex-row">
                                {Lang(lang, 'intermediate')} <div className="mx-2 h-2 w-2 rounded-full bg-[#FF6900]" /> <p className="text-[12px] font-normal">({(skills.filter(obj => obj?.skillStatus === 'Intermediate') || []).length})</p>
                            </h1>
                            <div className="flex flex-row flex-wrap">
                                {skills.filter(obj => obj?.skillStatus === 'Intermediate')?.map((skill, index) => (<SkillTag index={index} item={skill} />))}
                            </div>
                        </div>}
                        {(skills.filter(obj => obj?.skillStatus === 'Beginner') || []).length !== 0 && <div>
                            <div className="bg-[#48494B] h-[0.5px] mt-3 mb-5 w-full" />
                            <h1 className="text-gray-700 font-medium mb-3 text-black items-center flex flex-row">
                                {Lang(lang, 'beginner')} <div className="mx-2 h-2 w-2 rounded-full bg-[#2B7FFF]" /> <p className="text-[12px] font-normal">({(skills.filter(obj => obj?.skillStatus === 'Beginner') || []).length})</p>
                            </h1>
                            <div className="flex flex-row flex-wrap">
                                {skills.filter(obj => obj?.skillStatus === 'Beginner')?.map((skill, index) => (<SkillTag index={index} item={skill} />))}
                            </div>
                        </div>}
                        {localskills.length === 0 && isEdit && <button
                            type="button"
                            onClick={handleAdd}
                            className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
                        >
                            + {Lang(lang, 'add_skills')}
                        </button>}
                    </div>}
                {<form className="space-y-6">
                    {localskills.map((skill, index) => (
                        <div key={index} className="border border-gray-200 rounded-xl p-4 relative">
                            {(
                                <button
                                    type="button"
                                    onClick={() => handleLocalDelete(index, skill)}
                                    className="absolute top-3 right-3 text-red-500 hover:text-red-700"
                                >
                                    <img src={"/asset/icon/trash.svg"} className="w-[16px]" />
                                </button>
                            )}

                            <h3 className="text-gray-700 font-medium mb-3">
                                Skill {index + 1}
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
                                <div>
                                    <label className="block font-medium mb-1">{Lang(lang, 'skill_name')}<span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={skill.skillName || ""}
                                        onChange={(e) => handleChange(index, "skillName", e.target.value)}
                                        className={"bg-white w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                        placeholder="Skill Name"
                                    />
                                </div>

                                <div>
                                    <label className="block font-medium mb-1">Skill Level<span className="text-red-500">*</span></label>
                                    <div className="relative ">

                                        <select
                                            value={skill.skillStatus}
                                            onChange={(e) => handleChange(index, "skillStatus", e.target.value)}
                                            className={"bg-white appearance-none w-full rounded-full border border-gray-200 px-4 py-2 h-[60px]"}
                                        >
                                            <option value="" disabled>-- Level --</option>
                                            <option value="Beginner">{Lang(lang, 'beginner')}</option>
                                            <option value="Intermediate">{Lang(lang, 'intermediate')}</option>
                                            <option value="Advanced">{Lang(lang, 'advanced')}</option>
                                        </select>
                                        <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
                                            ▼
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="flex justify-between items-center">
                        {localskills.length !== 0 && (
                            <button
                                type="button"
                                onClick={handleAdd}
                                className="w-full text-blue-600 border border-dashed border-blue-300 rounded-full py-2 text-sm hover:bg-blue-50 mb-4"
                            >
                                + {Lang(lang, 'add_skills')}
                            </button>
                        )}
                    </div>
                </form>}

                {!(isFormReady()) && <div className="flex justify-end w-full mt-3">
                    <p className="text-red-500 text-xs mt-1 mr-0">{Lang(lang, 'required_error')}</p>
                </div>}


            </div>

            <div className="flex space-x-2 mt-3 justify-end w-full bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] p-3 rounded-xl sticky bottom-3">
                <button
                    type="button"
                    className="border border-gray-300 rounded-full px-4 py-1 text-sm hover:bg-gray-50"
                    onClick={() => {
                        setIsFading(true);
                        setTimeout(() => {
                            setCurrentTabIndex(currentTabIndex - 1);
                            setIsFading(false);
                        }, 200);
                    }}
                >
                    {Lang(lang, 'previous')}
                </button>
                <button
                    type="button"
                    className={
                        "rounded-full px-4 py-1 text-sm " +
                        (isEdit && isFormReady() && (localskills.length !== 0 || skills.length !== 0)
                            ? "text-white bg-red-500 hover:bg-red-600"
                            : "border border-red-500 text-red-500 hover:bg-gray-50")
                    }
                    onClick={async () => {
                        try {
                            if (isFormReady() && (localskills.length !== 0 || skills.length !== 0)) {
                                if (localskills.length != 0 && !isLoading) {
                                    await handleSave();
                                }
                                setIsFading(true);
                                setTimeout(() => {
                                    if ((currentTabIndex + 1) > profileCompletion) {
                                        updatePercentage(currentTabIndex + 1)
                                    }
                                    setCurrentTabIndex(currentTabIndex + 1);
                                    setIsFading(false);
                                }, 200);
                            }
                        } catch (error) {
                            showError(error)
                        }
                    }}
                >
                    {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" /> : isEdit ? Lang(lang, 'save_and_next') : `${Lang(lang, 'next')} ${currentTabIndex + 1}/10`}
                </button>
            </div>
        </div>
    );
};

export default SkillsForm;
